import { render, staticRenderFns } from "./CreateCampaignModal.vue?vue&type=template&id=1ecd98fe&scoped=true&"
import script from "./CreateCampaignModal.vue?vue&type=script&lang=ts&"
export * from "./CreateCampaignModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCampaignModal.vue?vue&type=style&index=0&id=1ecd98fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd98fe",
  null
  
)

export default component.exports